export const gradeValueText = true;
export const gradeList = ['Personal', 'Group'];